import { createSnackbarQueue } from '@rmwc/snackbar';

export const snackbarQueue = createSnackbarQueue()